import { OrgUserPreferenceResponse } from '@futrli-sdk/predict';
import { API_PATHS, REQUEST_METHODS, ROUTE_PARAMS, interpolatePathParams } from '@futrli/shared-services';
import { makeRequestWithResponse } from './shared';
import { PreferencesPayload } from '../../dashboard/types';

/**
 * Fetch user preferences
 */
export const fetchPreferences = async (
  workspaceId: string,
  organisationId: string,
  userId: string
): Promise<OrgUserPreferenceResponse> => {
  const path = interpolatePathParams(API_PATHS.PREFERENCES, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.USER_ID]: userId
  });

  return makeRequestWithResponse<OrgUserPreferenceResponse>({ url: path, method: REQUEST_METHODS.GET });
};

/**
 * Update user preferences
 */
export const updatePreferences = async (
  workspaceId: string,
  organisationId: string,
  userId: string,
  data: PreferencesPayload
): Promise<OrgUserPreferenceResponse> => {
  const path = interpolatePathParams(API_PATHS.PREFERENCES, {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.USER_ID]: userId
  });

  return makeRequestWithResponse<OrgUserPreferenceResponse>({
    url: path,
    method: REQUEST_METHODS.PUT,
    data: { data: { business_insights: data } }
  });
};
